export const chooseSlotByMatchId = (clickedMatchId: number): string =>
  `team_${clickedMatchId % 2 !== 0 ? 1 : 2}_id`;
